<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-flex xs12 mx-auto>
      <v-carousel
      cycle
      height="500px"
      hide-delimiter-background
      light
      :interval="interval"
      :show-arrows="false"
      @change="loadAllGraph()"
      >
        <v-carousel-item
        v-for="(slide, i) in screenList.filter(rec =>rec.view_access === 1)" :key="i"
        dark>
          <v-card-title class="pa-2">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs10 class="text-center">
                  {{ slide.screen_name }}
                </v-flex>
                <v-flex xs2 class="text-center">
                  <v-icon large color="#00897B" @click="viewScreenConfigure()" class="mdi-spin">mdi-cog</v-icon>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap v-if="slide.screen_name === 'HR Dashboard'" class="mt-4">
              <v-flex xs7>
                <v-layout row wrap>
                  <v-flex xs12 rounded style="margin-top: 10px;">
                    <v-layout>
                      <v-flex xs4>
                        <v-card class="grey lighten-4" style="height: 80px;">
                          <v-list-item>
                            <v-sheet
                            elevation="5"
                            height="45"
                            width="45"
                            class="amber darken-4"
                            style="margin-top: -20px;">
                              <v-icon large color="white" class="pa-1">mdi-ticket-account</v-icon>
                            </v-sheet>
                          </v-list-item>
                          <v-spacer></v-spacer>
                          <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold; color: #00897B">Total Staffs</div>
                          <div class="mr-3 mt-3" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; font-weight: bold; color: #1B5E20;">{{ empDetails.tot_staff}}</div>
                        </v-card>
                      </v-flex>
                      <v-flex xs4>
                        <v-card class="grey lighten-4" style="height: 80px;">
                          <v-list-item>
                            <v-sheet
                            elevation="5"
                            height="45"
                            width="45"
                            class="amber darken-4"
                            style="margin-top: -20px;">
                              <v-icon large color="white" class="pa-1">mdi-ticket-account</v-icon>
                            </v-sheet>
                          </v-list-item>
                          <v-spacer></v-spacer>
                          <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold; color: #00897B">Staffs</div>
                          <div class="mr-3 mt-0" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold;"><span style="color: #546E7A">Deployed : </span> <span style="color: green;">{{ empDetails.new_joinee }}</span></div>
                          <div class="mr-3 mt-0" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold;"><span style="color: #546E7A">Undeployed : </span> <span style="color: red;">{{ empDetails.left_employee }}</span></div>
                        </v-card>
                      </v-flex>
                      <v-flex xs4>
                        <v-card class="grey lighten-4" style="height: 80px;">
                          <v-list-item>
                            <v-sheet
                            elevation="5"
                            height="45"
                            width="45"
                            class="amber darken-4"
                            style="margin-top: -20px;">
                              <v-icon large color="white" class="pa-1">mdi-playlist-check</v-icon>
                            </v-sheet>
                          </v-list-item>
                          <v-spacer></v-spacer>
                          <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold; color: #00897B">Aadhar</div>
                          <div class="mr-3 mt-0" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold;"><span style="color: #546E7A">Collected : </span> <span style="color: green;">{{ empDetails.document_collected }}</span></div>
                          <div class="mr-3 mt-0" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold;"><span style="color: #546E7A">Pending : </span> <span style="color: red;">{{ empDetails.document_pending }}</span></div>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 rounded style="margin-top: 10px;">
                    <v-layout>
                      <v-flex xs4>
                        <v-card class="grey lighten-4" style="height: 80px;">
                          <v-list-item>
                            <v-sheet
                            elevation="5"
                            height="45"
                            width="45"
                            class="amber darken-4"
                            style="margin-top: -20px;">
                              <v-icon large color="white" class="pa-1">mdi-playlist-plus</v-icon>
                            </v-sheet>
                          </v-list-item>
                          <v-spacer></v-spacer>
                          <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold; color: #00897B">PF Number</div>
                          <div class="mr-3 mt-0" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold;"><span style="color: #546E7A">Created : </span> <span style="color: green;">{{ empDetails.pf_opted }}</span></div>
                          <div class="mr-3 mt-0" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold;"><span style="color: #546E7A">Pending : </span> <span style="color: red;">{{ empDetails.pf_opted_pending }}</span></div>
                        </v-card>
                      </v-flex>
                      <v-flex xs4>
                        <v-card class="grey lighten-4" style="height: 80px;">
                          <v-list-item>
                            <v-sheet
                            elevation="5"
                            height="45"
                            width="45"
                            class="amber darken-4"
                            style="margin-top: -20px;">
                              <v-icon large color="white" class="pa-1">mdi-playlist-plus</v-icon>
                            </v-sheet>
                          </v-list-item>
                          <v-spacer></v-spacer>
                          <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold; color: #00897B">ESI Number</div>
                          <div class="mr-3 mt-0" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold;"><span style="color: #546E7A">Created : </span> <span style="color: green;">{{ empDetails.esi_opted }}</span></div>
                          <div class="mr-3 mt-0" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold;"><span style="color: #546E7A">Pending : </span> <span style="color: red;">{{ empDetails.esi_opted_pending }}</span></div>
                        </v-card>
                      </v-flex>
                      <v-flex xs4>
                        <v-card class="grey lighten-4" style="height: 80px;">
                          <v-list-item>
                            <v-sheet
                            elevation="5"
                            height="45"
                            width="45"
                            class="amber darken-4"
                            style="margin-top: -20px;">
                              <v-icon large color="white" class="pa-1">mdi-account-off</v-icon>
                            </v-sheet>
                          </v-list-item>
                          <v-spacer></v-spacer>
                          <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold; color: #00897B">No ESI Card</div>
                          <div class="mr-3 mt-2" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; font-weight: bold; color: #1B5E20;">{{ empDetails.esic_card_not_generated}}</div>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 rounded style="margin-top: 10px;">
                    <v-layout>
                      <v-flex xs4>
                        <v-card class="grey lighten-4" style="height: 80px;">
                          <v-list-item>
                            <v-sheet
                            elevation="5"
                            height="45"
                            width="45"
                            class="amber darken-4"
                            style="margin-top: -20px;">
                              <v-icon large color="white" class="pa-1">mdi-bank</v-icon>
                            </v-sheet>
                          </v-list-item>
                          <v-spacer></v-spacer>
                          <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold; color: #00897B">No Bank Account</div>
                          <div class="mr-3 mt-3" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; font-weight: bold; color: #1B5E20;">{{ empDetails.bank_acc_no_updated}}</div>
                        </v-card>
                      </v-flex>
                      <v-flex xs4>
                        <v-card class="grey lighten-4" style="height: 80px;">
                          <v-list-item>
                            <v-sheet
                            elevation="5"
                            height="45"
                            width="45"
                            class="amber darken-4"
                            style="margin-top: -20px;">
                              <v-icon large color="white" class="pa-1">mdi-alarm-check</v-icon>
                            </v-sheet>
                          </v-list-item>
                          <v-spacer></v-spacer>
                          <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold; color: #00897B">PAN Updated</div>
                          <div class="mr-3 mt-3" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 20px; font-weight: bold; color: #1B5E20;">{{ empDetails.pan_no_updated}}</div>
                        </v-card>
                      </v-flex>
                      <v-flex xs4>
                        <v-card class="grey lighten-4" style="height: 80px;">
                          <v-list-item>
                            <v-sheet
                            elevation="5"
                            height="45"
                            width="45"
                            class="amber darken-4"
                            style="margin-top: -20px;">
                              <v-icon large color="white" class="pa-1">mdi-watch-import</v-icon>
                            </v-sheet>
                          </v-list-item>
                          <v-spacer></v-spacer>

                          <div class="mr-3" style="margin-top: -40px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold; color: #00897B">BGV</div>
                          <div class="mr-3 mt-0" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold;"><span style="color: #546E7A">Done : </span> <span style="color: green;">{{ empDetails.verif_done }}</span></div>
                          <div class="mr-3 mt-0" style="text-align:right; font-family: Roboto,sans-serif!important; font-size: 16px; font-weight: bold;"><span style="color: #546E7A">Pending : </span> <span style="color: red;">{{ empDetails.verif_not_done }}</span></div>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm4 class="pt-8 mt-5 ml-7">
                <v-card class="elevation-6">
                  <v-card-text>
                    <v-layout row wrap class="pl-0 pr-0 text-center">
                      <v-flex>
                        <v-sheet
                        style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #26A69A"
                        class="elevation-0"
                        >
                          <div id="div_chartDataForTotalMaleFemale" class="elevation-7 pa-3" >
                            <canvas id="chart_chartDataForTotalMaleFemale"></canvas>
                          </div>
                        </v-sheet>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap class="text-center">
                      <v-flex>
                        <v-layout row wrap class="pl-3 pr-1 text-left">
                          <v-flex>
                            <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #555555; line-height: 1.4em">Total Male and Female counts</div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout v-if="slide.screen_name === 'Management Dashboard'">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-card>
                    <v-card-text class="pa-0">
                      <!-- top 10 screens for smartility and backbone graph view -->
                      <v-flex xs12>
                        <v-layout row wrap class="pt-5">
                          <v-flex xs12 sm6 class="pt-12">
                            <v-card class="elevation-6">
                              <v-card-text>
                                <v-layout xs12 row wrap class="pl-0 pr-0 text-center">
                                  <v-flex>
                                    <v-sheet
                                    style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #78909C"
                                    class="elevation-0"
                                    rounded="xl"
                                    >
                                    <div id="div_usageMetrics" class="elevation-7 pa-3" >
                                      <canvas id="chart_usageMetrics"></canvas>
                                    </div>
                                  </v-sheet>
                                </v-flex>
                              </v-layout>
                              <v-layout xs12 row wrap class="text-center">
                                <v-flex>
                                  <v-layout row wrap class="pl-3 pr-1 text-left">
                                    <v-flex>
                                      <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 16px; color: #555555; line-height: 1.4em">Smartility Top 10 Screens</div>
                                      <div class="pt-1" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #999999; line-height: 1.4em">Accessed at Smartility</div>
                                      <div class="pt-3" > <hr></hr></div>
                                      <template>
                                        <div class="pt-1" style="font-family: Roboto,sans-serif!important; font-size: 13px; color: #999999; line-height: 1.4em">
                                          <v-icon class="mr-1" small>mdi-clock</v-icon>Updated on   {{loaded_date}}</div>
                                        </template>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm6 class="pt-12">
                            <v-card class="elevation-6">
                              <v-card-text>
                                <v-layout xs12 row wrap class="pl-0 pr-0 text-center">
                                  <v-flex>
                                    <v-sheet
                                    style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #26A69A"
                                    class="elevation-0"
                                    >
                                    <div id="div_usageMetrics_bb" class="elevation-7 pa-3" >
                                      <canvas id="chart_usageMetrics_bb"></canvas>
                                    </div>
                                  </v-sheet>
                                </v-flex>
                              </v-layout>
                              <v-layout xs12 row wrap class="text-center">
                                <v-flex>
                                  <v-layout row wrap class="pl-3 pr-1 text-left">
                                    <v-flex>
                                      <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 16px; color: #555555; line-height: 1.4em">Backbone Top 10 Screens</div>
                                      <div class="pt-1" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #999999; line-height: 1.4em">Accessed at Backbone</div>
                                      <div class="pt-3" > <hr></hr></div>
                                      <template>
                                        <div class="pt-1" style="font-family: Roboto,sans-serif!important; font-size: 13px; color: #999999; line-height: 1.4em">
                                          <v-icon class="mr-1" small>mdi-clock</v-icon>Updated on   {{loaded_date}}</div>
                                        </template>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <!-- <v-flex xs12>
                        <v-layout row wrap class="pt-5">
                          <v-flex xs12 sm6 class="pt-12">
                            <v-card class="elevation-6">
                              <v-card-text>
                                <v-layout xs12 row wrap class="pl-0 pr-0 text-center">
                                  <v-flex>
                                    <v-sheet
                                    style="margin-top: -50px; margin-left: 10px; margin-right: 10px; backgroundColor: #E91E63"
                                    class="elevation-0"
                                    rounded="xl"
                                    >
                                    <div id="div_usageMetricsForUser_sm" class="elevation-7 pa-3" >
                                      <canvas id="chart_usageMetricsForUser_sm"></canvas>
                                    </div>
                                  </v-sheet>
                                </v-flex>
                              </v-layout>
                              <v-layout xs12 row wrap class="text-center">
                                <v-flex>
                                  <v-layout row wrap class="pl-3 pr-1 text-left">
                                    <v-flex>
                                      <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 16px; color: #555555; line-height: 1.4em">Smartility Top 10 Users</div>
                                      <div class="pt-1" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #999999; line-height: 1.4em">Accessed at Smartility</div>
                                      <div class="pt-3" > <hr></hr></div>
                                      <template>
                                        <div class="pt-1" style="font-family: Roboto,sans-serif!important; font-size: 13px; color: #999999; line-height: 1.4em">
                                          <v-icon class="mr-1" small>mdi-clock</v-icon>Updated on   {{loaded_date}}</div>
                                        </template>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm6 class="pt-12">
                            <v-card class="elevation-6">
                              <v-card-text>
                                <v-layout xs12 row wrap class="pl-0 pr-0 text-center">
                                  <v-flex>
                                    <v-sheet
                                    style="margin-top: -50px; margin-left: 10px; margin-right: 10px;"
                                    class="elevation-0 success"
                                    >
                                    <div id="div_usageMetricsForUser_bb" class="elevation-7 pa-3" >
                                      <canvas id="chart_usageMetricsForUser_bb"></canvas>
                                    </div>
                                  </v-sheet>
                                </v-flex>
                              </v-layout>
                              <v-layout xs12 row wrap class="text-center">
                                <v-flex>
                                  <v-layout row wrap class="pl-3 pr-1 text-left">
                                    <v-flex>
                                      <div class="pt-2" style="font-family: Roboto,sans-serif!important; font-size: 16px; color: #555555; line-height: 1.4em">Backbone Top 10 Users</div>
                                      <div class="pt-1" style="font-family: Roboto,sans-serif!important; font-size: 14px; color: #999999; line-height: 1.4em">Accessed at Backbone</div>
                                      <div class="pt-3" > <hr></hr></div>
                                      <template>
                                        <div class="pt-1" style="font-family: Roboto,sans-serif!important; font-size: 13px; color: #999999; line-height: 1.4em">
                                          <v-icon class="mr-1" small>mdi-clock</v-icon>Updated on   {{loaded_date}}</div>
                                        </template>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex> -->
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-layout>

            <v-layout row wrap v-if="slide.screen_name === 'Operation Dashboard'">
              <!-- Field Officer View -->
              <v-flex>
                <v-layout row wrap>
                  <v-flex xs12 sm4 v-for="(role, n) in roleList" :key="n">
                    <v-card>
                      <v-card-title class="pa-2 primary--text grey lighten-4" style="font-family: 'Verdana', cursive; font-size:20px; font-weight:bold">
                        <span>{{ role }}</span>
                      </v-card-title>
                      <v-card-text class="pa-2">
                        <v-layout row wrap class="subtitle-2 black--text">
                          <v-flex xs12>
                            <v-layout row wrap>
                              <v-flex xs6>
                                <v-card flat class="grey lighten-4" style="font-family: 'Verdana'; font-size:14px; font-weight:bold">
                                  <div class="red--text text-center grey lighten-3">
                                    Total Absent
                                  </div>
                                  <div class="text-center" style="font-family: 'Satisfy'; font-size:24px; font-weight:bold" v-if="staffRoleCount[role]">
                                    {{staffRoleCount[role].absent_percent + ' %'}}
                                  </div>
                                </v-card>
                              </v-flex>
                              <v-flex xs6>
                                <v-card flat class="grey lighten-4" style="font-family: 'Verdana'; font-size:14px; font-weight:bold">
                                  <div class="green--text text-center grey lighten-3">
                                    Total Present
                                  </div>
                                  <div class="text-center" style="font-family: 'Satisfy'; font-size:24px; font-weight:bold" v-if="staffRoleCount[role]">
                                    {{staffRoleCount[role].present_percent + ' %'}}
                                  </div>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12>
                            <v-layout row wrap>
                              <v-flex xs6>
                                <v-card flat class="grey lighten-4" style="font-family: 'Verdana'; font-size:14px; font-weight:bold">
                                  <div class="blue--text text-center grey lighten-3">
                                    Community
                                  </div>
                                  <div class="text-center" style="font-family: 'Satisfy'; font-size:24px; font-weight:bold" v-if="staffRoleCount[role]">
                                    {{staffRoleCount[role].total_community }}
                                  </div>
                                </v-card>
                              </v-flex>
                              <v-flex xs6>
                                <v-card flat class="grey lighten-4" style="font-family: 'Verdana'; font-size:14px; font-weight:bold">
                                  <div class="blue--text text-center grey lighten-3">
                                    Absenties
                                  </div>
                                  <div class="text-center" style="font-family: 'Satisfy'; font-size:24px; font-weight:bold" v-if="staffRoleCount[role]">
                                    {{staffRoleCount[role].total_absent }}
                                  </div>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- backoffice dashboard-->
            <v-layout v-if="slide.screen_name === 'Back Office Dashboard'">
              <v-flex xs12>
                <v-layout row wrap>
                  <v-data-table
                  :headers="headerForBBDash"
                  :items="dashboardTicketDetail"
                  hide-default-footer
                  hide-default-header
                  disable-pagination
                  :mobile-breakpoint="0"
                  class="elevation-2">
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th class="info lighten-2 black--text" style="font-size: 16px; font-weight: bold; width: 250px; text-align: center">{{headers[0].text}}</th>
                          <th class="info lighten-2 black--text" style="font-size: 16px; font-weight: bold; width: 200px; text-align: center">{{headers[1].text}}</th>
                          <th class="info lighten-2 black--text" style="font-size: 16px; font-weight: bold; width: 250px; text-align: center">{{headers[2].text}}</th>
                          <th class="info lighten-2 black--text" style="font-size: 16px; font-weight: bold; width: 200px; text-align: center">{{headers[3].text}}</th>
                          <th class="info lighten-2 black--text" style="font-size: 16px; font-weight: bold; width: 300px; text-align: center">{{headers[4].text}}</th>
                          <th class="info lighten-2 black--text" style="font-size: 16px; font-weight: bold; width: 300px; text-align: center">{{headers[5].text}}</th>
                          <th class="info lighten-2 black--text" style="font-size: 16px; font-weight: bold; width: 250px; text-align: center">{{headers[6].text}}</th>
                          <th class="info lighten-2 black--text" style="font-size: 16px; font-weight: bold; width: 200px; text-align: center">{{headers[7].text}}</th>
                        </tr>
                      </thead>
                    </template>
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td class="warning lighten-1 black--text" style="font-size: 16px; font-weight: bold; text-align: center">{{ props.item.dept_name }}</td>
                        <td class="blue--text" style="font-size: 20px; font-weight: bold; text-align: center">{{ handy.formatNum(props.item.open_ticket) }}</td>
                        <td class="green--text" style="font-size: 20px; font-weight: bold; text-align: center">{{ handy.formatNum(props.item.closed_ticket) }}</td>
                        <td class="red--text" style="font-size: 20px; font-weight: bold; text-align: center">{{ handy.formatNum(props.item.new_ticket) }}</td>
                        <td class="teal--text" style="font-size: 20px; font-weight: bold; text-align: center">{{ handy.formatNum(props.item.onhold_ticket) }}</td>
                        <td class="green--text" style="font-size: 20px; font-weight: bold; text-align: center">{{ handy.formatNum(props.item.job_done_ticket) }}</td>
                        <td class="teal--text" style="font-size: 20px; font-weight: bold; text-align: center">{{ handy.formatNum(props.item.unassigned_ticket) }}</td>
                        <td style="font-size: 20px; font-weight: bold; text-align: center">{{ handy.formatNum(props.item.tot_ticket) }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-carousel-item>
      </v-carousel>

      <v-dialog v-model="showScreenConfigure" persistent max-width="600px">
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="title primary--text grey lighten-4 pa-2">
            Configuration
            <v-spacer></v-spacer>
            <v-btn small icon @click.stop="showScreenConfigure = false"><v-icon>mdi-close</v-icon></v-btn>
            <v-flex xs12 class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="primary--text" icon small @click="createConfig()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                </template>
                <span>Add New</span>
              </v-tooltip>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-flex class="pa-1">
              <v-data-table
              :headers="configHeader"
              :items="screenList"
              hide-default-footer
              class="elevation-2"
              :mobile-breakpoint="0"
              disable-pagination
              >
                <template slot="item" slot-scope="props">
                  <tr>
                    <td>{{ props.item.screen_name }}</td>
                    <td>{{ props.item.screen_duration }}</td>
                    <td><v-checkbox disabled v-model="props.item.view_access" hide-details class="pb-5"></v-checkbox></td>
                    <td>
                      <v-btn icon small class="mr-0"><v-icon small @click="prepareEdit(props.item)">mdi-pencil</v-icon></v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
        </v-card>

        <!-- 8. create / edit dept -->
        <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid grid-list-md>
          <v-form ref="acForm" @submit.prevent="saveScreenConfig(lAction)">
            <v-card flat class="pa-0">
              <v-card-title class="title pb-0">
                {{ handy.startWithUpper(lAction) }} Screen Configuration
              </v-card-title>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lConfig.screen_name"
                    label="Screen name"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="50">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lConfig.screen_duration"
                    label="Screen duration"
                    hide-details
                    :rules="[rules.required]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                    v-model="lConfig.view_access"
                    label="View Access"
                    hide-details
                    class="shrink"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.stop="cancelChanges">Cancel</v-btn>
                <v-btn v-if="lAction === 'update'" :disabled="beingSaved" @click="deleteScreenConfig(lConfig)">delete</v-btn>
                <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-container>
      </v-dialog>
    </v-flex>
  </v-container>
</template>

<script>

import handy from '@/utils/handy'
import config from '@/config/app-cfg'

var Chart = require('chart.js')

var COLORS = ['227,108,9', '49,133,155', '95,73,122', '118,146,60', '149,55,52', '54,96,146', '23,54,93', '73,68,41']

export default {
  data () {
    return {
      screenList: [],
      handy: handy,
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      config: config,
      rules: handy.rules,
      interval: 30000,
      empDetails: [],
      chartDataForTotalMaleFemale: [],
      tmpChart: [],
      usageMetricsForSmart: [],
      usageMetricsForBB: [],
      usageMetricsForBbUser: [],
      usageMetricsForSmUser: [],
      showScreenConfigure: false,
      beingSaved: false,
      lConfig: {},
      lAction: 'view',
      configHeader: [
        { text: 'Screen Name', value: 'screen_name', width: '55%', sortable: false },
        { text: 'Screen Duration', value: 'screen_duration', sortable: false },
        { text: 'View', value: 'view_access', sortable: false },
        { text: 'Action', value: '', sortable: false }
      ],
      lDate: '',
      roleList: ['HouseKeeper', 'Gardener', 'STP Operator', 'Electrician', 'Plumber'],
      staffRoleCount: {'HouseKeeper': [], 'Gardener': [], 'STP Operator': [], 'Electrician': [], 'Plumber': []},
      dashboardTicketDetail: [],
      loaded_date: '',
      departmentList: [],
      headerForBBDash: [
        { text: 'Department Name', value: 'dept_name' },
        { text: 'Open Ticket', value: 'open_ticket' },
        { text: 'Closed Ticket', value: 'closed_ticket' },
        { text: 'New Ticket', value: 'new_ticket' },
        { text: 'On-Hold Ticket', value: 'onhold_ticket' },
        { text: 'Job Done Ticket', value: 'job_done_ticket' },
        { text: 'Unassigned Ticket ', value: 'unassigned_ticket' },
        { text: 'Total Ticket ', value: 'tot_ticket' }
      ]
    }
  },
  mounted () {
    this.loadConfiguredScreens()
    this.loadEmployeeDet()
    // this.loadUsageMetricGraphForSmartilityAndBB()
    var curDate = new Date()
    this.lDate = handy.formatDBDate(curDate)
    this.loadFieldOffice(this.lDate, this.lDate)
    this.loadDepartmentList()
    this.loadDashboardTicketCount()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadConfiguredScreens () {
      this.axios.get(config.API_URL + '/getConfiguredScreens/')
      .then(response => {
        this.screenList = response.data
        // this.screenList = response.data.filter(rec =>rec.view_access === 1)
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.screenList = []
      })
    },
    loadEmployeeDet () {
      this.axios.get(config.API_URL + '/getEmployeeDetCount/')
      .then(response => {
        this.empDetails = response.data[0]
      })
      .catch(err => {
        this.msg(err)
        this.empDetails = []
      })
    },
    loadMaleFemaleChartData () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.chartDataForTotalMaleFemale = []
      this.axios.get(config.API_URL + '/getChartDataFortotalMaleAndFemale/', qry)
      .then(response => {
        if (response.data.length > 0) {
          var tmpVar = []
          var totStaff = response.data[0].tot_male + response.data[0].tot_female
          tmpVar.push(((response.data[0].tot_male / totStaff) * 100).toFixed(0))
          tmpVar.push(((response.data[0].tot_female / totStaff) * 100).toFixed(0))
          this.chartDataForTotalMaleFemale.push(response.data[0].tot_male)
          this.chartDataForTotalMaleFemale.push(response.data[0].tot_female)
          setTimeout(() => {
            document.getElementById('div_chartDataForTotalMaleFemale').innerHTML = '<canvas id="chart_chartDataForTotalMaleFemale"></canvas>'
            var canvas = document.getElementById('chart_chartDataForTotalMaleFemale')
            var ctx = canvas.getContext('2d')
            ctx.canvas.height = 250
            this.tmpChart = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Male', 'Female'],
                datasets: [{
                  backgroundColor: ['#FFA726', '#9CCC65'],
                  data: this.chartDataForTotalMaleFemale
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function (value) {
                      return value > 0 ? value : ''
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  fontSize: 16
                },
                legend: {
                  position: 'bottom',
                  labels: {
                    usePointStyle: false,
                    fontColor: "white",
                    fontSize: 11
                  }
                }
              }
            })
          }, 500)
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadUsageMetricGraphForSmartilityAndBB () {
      this.loadUpdatedDateTime ()
      var dates = []
      var curDate = new Date()
      var lDateTo = handy.formatDBDate(curDate)
      var lDateFrom = handy.formatDBDate(curDate.setMonth(curDate.getMonth()-1))
      dates.push(lDateFrom + ' 00:00:00')
      dates.push(lDateTo + ' 23:59:59')
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          view_date_time: dates
        }
      }
      this.usageMetricsForBB = []
      this.usageMetricsForSmart = []
      this.usageMetricsForSmUser = []
      this.usageMetricsForBbUser = []
      this.axios.get(config.API_URL + '/getTop20ScreenAndUserForSmartilityAndBB/', qry)
      .then(response => {
        if (response.data.length) {
          this.usageMetricsForBB = response.data[0]
          this.usageMetricsForSmart = response.data[1]
          this.usageMetricsForSmUser = response.data[3]
          this.usageMetricsForBbUser = response.data[2]
        }
        setTimeout(() => {
          document.getElementById('div_usageMetrics').innerHTML = '<canvas id="chart_usageMetrics"></canvas>'
          var canvas = document.getElementById('chart_usageMetrics')
          var ctx = canvas.getContext('2d')
          ctx.canvas.height = 190
          this.tmpChart = new Chart(ctx, {
            type: 'horizontalBar',
            data: {
              labels: this.usageMetricsForSmart.map(rec =>rec.screen_name),
              datasets: [{
                backgroundColor: '#FFCC80',
                borderColor: "rgba(219, 0, 0, 1)",
                data: this.usageMetricsForSmart.map(rec =>rec.tot_screen_count),
                fill: true
              }]
            },
            options: {
              layout: {
                padding: 0
              },
              plugins: {
                datalabels: {
                  formatter: function (value) {
                    return value || ''
                  },
                  color: '#000000',
                  fontSize: 11,
                }
              },
              tooltips: {enabled: false},
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    min: 0,
                    fontColor: '#ffffff'
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.4,
                    display: true,
                    borderDash: [1, 2],
                    color: "white",
                    zeroLineColor: "#E91E63"
                  }
                }],
                yAxes: [{
                  ticks: {
                    display: true,
                    fontColor: '#ffffff',
                    beginAtZero: true,
                    min: 0
                  },
                  grid: {
                    display: false,
                    offset: true
                  },
                  gridLines: {
                    lineWidth: 0.4,
                    display: true,
                    borderDash: [1, 2],
                    color: "white"
                  }
                }]
              },
              hover: {
                animationDuration: 0
              }
            }
          })
        }, 500)

        document.getElementById('div_usageMetrics_bb').innerHTML = '<canvas id="chart_usageMetrics_bb"></canvas>'
        var canvas = document.getElementById('chart_usageMetrics_bb')
        var ctx = canvas.getContext('2d')
        ctx.canvas.height = 190
        this.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: this.usageMetricsForBB.map(rec =>rec.screen_name),
            datasets: [{
              backgroundColor: '#9CCC65',
              data: this.usageMetricsForBB.map(rec =>rec.tot_screen_count),
              fill: true
            }]
          },
          options: {
            layout: {
              padding: 0
            },
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return value || ''
                },
                color: '#000000',
                fontSize: 11,
              }
            },
            tooltips: {enabled: false},
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  display: true,
                  fontColor: '#ffffff',
                  beginAtZero: true,
                  min: 0,
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.4,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "#00C853"
                }
              }],
              yAxes: [{
                ticks: {
                  display: true,
                  fontColor: '#ffffff',
                  beginAtZero: true,
                  min: 0
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.4,
                  display: true,
                  borderDash: [1, 2],
                  color: "white"
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        })

        document.getElementById('div_usageMetricsForUser_sm').innerHTML = '<canvas id="chart_usageMetricsForUser_sm"></canvas>'
        var canvas = document.getElementById('chart_usageMetricsForUser_sm')
        var ctx = canvas.getContext('2d')
        ctx.canvas.height = 190
        this.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: this.usageMetricsForSmUser.map(rec =>rec.cust_name),
            datasets: [{
              backgroundColor: '#ffffff',
              data: this.usageMetricsForSmUser.map(rec =>rec.tot_screen_count),
              fill: true
            }]
          },
          options: {
            layout: {
              padding: 0
            },
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return value || ''
                },
                color: '#00C853',
                fontSize: 11,
              }
            },
            tooltips: {enabled: false},
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  display: true,
                  fontColor: '#ffffff',
                  beginAtZero: true,
                  min: 0,
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.4,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "#00C853"
                }
              }],
              yAxes: [{
                ticks: {
                  display: true,
                  fontColor: '#ffffff',
                  beginAtZero: true,
                  min: 0
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.4,
                  display: true,
                  borderDash: [1, 2],
                  color: "white"
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        })

        document.getElementById('div_usageMetricsForUser_bb').innerHTML = '<canvas id="chart_usageMetricsForUser_bb"></canvas>'
        var canvas = document.getElementById('chart_usageMetricsForUser_bb')
        var ctx = canvas.getContext('2d')
        ctx.canvas.height = 190
        this.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: this.usageMetricsForBbUser.map(rec =>rec.emp_name),
            datasets: [{
              backgroundColor: '#ffffff',
              data: this.usageMetricsForBbUser.map(rec =>rec.tot_screen_count),
              fill: true
            }]
          },
          options: {
            layout: {
              padding: 0
            },
            plugins: {
              datalabels: {
                formatter: function (value) {
                  return value || ''
                },
                color: '#00C853',
                fontSize: 11,
              }
            },
            tooltips: {enabled: false},
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  display: true,
                  fontColor: '#ffffff',
                  beginAtZero: true,
                  min: 0,
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.4,
                  display: true,
                  borderDash: [1, 2],
                  color: "white",
                  zeroLineColor: "#00C853"
                }
              }],
              yAxes: [{
                ticks: {
                  display: true,
                  fontColor: '#ffffff',
                  beginAtZero: true,
                  min: 0
                },
                grid: {
                  display: false,
                  offset: true
                },
                gridLines: {
                  lineWidth: 0.4,
                  display: true,
                  borderDash: [1, 2],
                  color: "white"
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        })

      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    viewScreenConfigure () {
      this.showScreenConfigure = true
    },
    createConfig () {
      this.lConfig = {
        screen_name: '',
        screen_duration: '',
        view_access: false
      }
      this.lAction = 'create'
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    saveScreenConfig (action) {
      // validate and save Changes
      if (this.$refs.acForm.validate()) {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/screenConfig/' + this.lAction, this.lConfig)
        .then(response => {
          this.msg('Saved successfully', 1)
          // refresh the Category list
          this.loadConfiguredScreens()
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err)
          this.beingSaved = false
        })
      }
    },
    prepareEdit (curScreen) {
      this.lConfig = Object.assign({}, curScreen) // keep the original object safely before changes
      this.lAction = 'update'
      this.showScreenConfigure = true
    },
    deleteScreenConfig (curScreen) {
      if (!confirm('Sure, you want to delete the config for screen "' + curScreen.screen_name + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/screenConfig/delete', curScreen)
      .then(response => {
        this.loadConfiguredScreens()
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    loadFieldOffice (fromDate, toDate, isAllShift) {
      var fromTodates = []
      fromTodates.push(fromDate)
      fromTodates.push(toDate)
      this.roleList.forEach(rec => {
        this.loadstaffRoleCount(fromTodates, rec)
      })
    },
    loadstaffRoleCount (curDates, curRole) {
      var qry = {
        params: {
          att_dt: curDates,
          vendor_id: config.VENDOR_ID,
          staff_role: curRole,
          minPercent: '80'
        }
      }
      this.staffRoleCount[curRole] = {
        present_percent: 0,
        absent_percent: 0,
        total_absent: 0,
        total_community: 0
      }
      this.axios.get(config.API_URL + '/getRolewisePercent/', qry)
      .then(response => {
        if (response.data) {
          // first result set from SP
          if(curRole === response.data[0][0].staff_role) {
            this.staffRoleCount[curRole].total_absent = response.data[0][0].tot_absent
            this.staffRoleCount[curRole].total_community = response.data[0][0].tot_comm
          }
          // second result set from SP
          if(curRole === response.data[1][0].staff_role) {
            this.staffRoleCount[curRole].present_percent = Math.round(response.data[1][0].avg_present_per)
            this.staffRoleCount[curRole].absent_percent = Math.round(response.data[1][0].avg_absent_per)
          }
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadDashboardTicketCount () {
        var qry = {
          params: {
            vendor_id: config.VENDOR_ID,
          }
        }
        this.axios.get(config.API_URL + '/getBBDashboardTicketCount/', qry)
        .then(response => {
          this.dashboardTicketDetail = response.data
        })
        .catch(err => {
          this.msg(err, true)
      })
    },
    loadDepartmentList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getDepartmentsList/', qry)
      .then(response => {
        this.departmentList = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadAllGraph () {
      this.loadMaleFemaleChartData()
      this.loadUsageMetricGraphForSmartilityAndBB()
    },
    loadUpdatedDateTime () {
      var curDate = new Date()
      this.loaded_date = handy.formatDisplayDateTime(curDate)
    }
  }
}
</script>
